import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useBilingual } from '../hooks/useBilingual';
import './CertificatesPage.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const CertificatesPage = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { tb } = useBilingual();
  
  // ?�버�? i18n ?�태 ?�인
  useEffect(() => {
    console.log('?�� [CertificatesPage] Current language:', i18n.language);
    console.log('?�� [CertificatesPage] Translation test:', tb('certificates.title'));
    console.log('?�� [CertificatesPage] i18n initialized:', i18n.isInitialized);
    console.log('?���?[CertificatesPage] Available languages:', Object.keys(i18n.options.resources || {}));
  }, [i18n, t]);
  
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); // all, BOOK, AGGREGATE
  const [stats, setStats] = useState({
    total: 0,
    book: 0,
    aggregate: 0,
    avgLevel: 0,
    avgAP: 0
  });

  useEffect(() => {
    fetchCertificates();
  }, [filter]);

  const fetchCertificates = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const user = JSON.parse(localStorage.getItem('user') || '{}');

      if (!token || !user.id) {
        navigate('/login');
        return;
      }

      // scope ?�라미터 ?�정
      let url = `${API_BASE_URL}/api/v2/certificates?status=active`;
      if (filter !== 'all') {
        url += `&scope=${filter}`;
      }

      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.status === 401 || response.status === 403) {
        // 토큰 만료 또는 인증 오류 → 로그인 페이지로 이동
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login');
        return;
      }

      if (!response.ok) {
        throw new Error('Failed to fetch certificates');
      }

      const data = await response.json();
      setCertificates(data);

      // ?�계 계산
      const bookCerts = data.filter(c => c.scope === 'BOOK');
      const aggCerts = data.filter(c => c.scope === 'AGGREGATE');
      const totalLevel = data.reduce((sum, c) => sum + c.level, 0);
      const totalAP = data.reduce((sum, c) => sum + c.absolute_percentile, 0);

      setStats({
        total: data.length,
        book: bookCerts.length,
        aggregate: aggCerts.length,
        avgLevel: data.length > 0 ? (totalLevel / data.length).toFixed(1) : 0,
        avgAP: data.length > 0 ? (totalAP / data.length).toFixed(1) : 0
      });

    } catch (error) {
      console.error('Error fetching certificates:', error);
    } finally {
      setLoading(false);
    }
  };

  const getLevelColor = (level) => {
    const colors = {
      1: 'var(--duo-blue)',
      2: 'var(--duo-green)',
      3: 'var(--duo-yellow)',
      4: '#FF9500',
      5: 'var(--duo-purple)',
      6: 'var(--duo-red)'
    };
    return colors[level] || 'var(--duo-blue)';
  };

  const getAPGrade = (ap) => {
    if (ap >= 80) return { label: '최우수 (Distinguished)', color: '#4444ff' };
    if (ap >= 60) return { label: '우수 (Advanced)', color: '#44dd44' };
    if (ap >= 40) return { label: '보통 (Proficient)', color: '#ffdd44' };
    if (ap >= 20) return { label: '기초 (Basic)', color: '#ff9944' };
    return { label: '기초 이하 (Below Basic)', color: '#ff4444' };
  };

  if (loading) {
    return (
      <div className="certificates-page">
        <div className="loading-center">
          <div className="loading-spinner"></div>
          <p>{tb('certificates.loading')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="certificates-page">
      <div className="certificates-container">
        
        {/* Header */}
        <div className="page-header">
          <h1 className="page-title">
            {tb('certificates.title')}
          </h1>
          <p className="page-subtitle">{tb('certificates.subtitle')}</p>
        </div>

        {/* Stats Cards */}
        <div className="cert-stats-grid">
          <div className="cert-stat-card total-card">
            <div className="stat-icon">T</div>
            <div className="stat-content">
              <div className="stat-value">{stats.total}</div>
              <div className="stat-label">{tb('certificates.stats.total')}</div>
            </div>
          </div>

          <div className="cert-stat-card book-card">
            <div className="stat-icon">B</div>
            <div className="stat-content">
              <div className="stat-value">{stats.book}</div>
              <div className="stat-label">{tb('certificates.stats.book')}</div>
            </div>
          </div>

          <div className="cert-stat-card aggregate-card">
            <div className="stat-icon">A</div>
            <div className="stat-content">
              <div className="stat-value">{stats.aggregate}</div>
              <div className="stat-label">{tb('certificates.stats.aggregate')}</div>
            </div>
          </div>

          <div className="cert-stat-card level-card">
            <div className="stat-icon">L</div>
            <div className="stat-content">
              <div className="stat-value">{stats.avgLevel}</div>
              <div className="stat-label">{tb('certificates.stats.avgLevel')}</div>
            </div>
          </div>
        </div>

        {/* Filter Tabs */}
        <div className="filter-tabs">
          <button 
            className={`filter-tab ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
          >
            {tb('certificates.filter.all')} ({stats.total})
          </button>
          <button 
            className={`filter-tab ${filter === 'BOOK' ? 'active' : ''}`}
            onClick={() => setFilter('BOOK')}
          >
            {tb('certificates.filter.book')} ({stats.book})
          </button>
          <button 
            className={`filter-tab ${filter === 'AGGREGATE' ? 'active' : ''}`}
            onClick={() => setFilter('AGGREGATE')}
          >
            {tb('certificates.filter.aggregate')} ({stats.aggregate})
          </button>
        </div>

        {/* Certificates Grid */}
        {certificates.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">-</div>
            <h3>{tb('certificates.empty.title')}</h3>
            <p>{tb('certificates.empty.description')}</p>
            <button 
              className="btn btn-primary"
              onClick={() => navigate('/test')}
            >
              {tb('certificates.empty.action')}
            </button>
          </div>
        ) : (
          <div className="certificates-grid">
            {certificates.map((cert) => (
              <CertificateCard 
                key={cert.certificate_id} 
                cert={cert} 
                navigate={navigate}
                getLevelColor={getLevelColor}
                getAPGrade={getAPGrade}
              />
            ))}
          </div>
        )}

      </div>
    </div>
  );
};

// Certificate Card Component
const CertificateCard = ({ cert, navigate, getLevelColor, getAPGrade }) => {
  const { t } = useTranslation();
  const { tb } = useBilingual();
  const apGrade = getAPGrade(cert.absolute_percentile);
  const levelColor = getLevelColor(cert.level);

  return (
    <div 
      className="certificate-card"
      onClick={() => navigate(`/certificates/${cert.certificate_id}`)}
    >
      {/* Card Header */}
      <div className="cert-card-header" style={{ borderTopColor: levelColor }}>
        <div className="cert-type-badge" style={{ background: cert.scope === 'BOOK' ? 'var(--duo-blue)' : 'var(--duo-purple)' }}>
          {cert.scope === 'BOOK' ? 'BOOK' : 'AGGREGATE'}
        </div>
        <div className="cert-serial">{cert.serial_no}</div>
      </div>

      {/* Card Body */}
      <div className="cert-card-body">
        {/* Title */}
        <h3 className="cert-title">
          {cert.scope === 'BOOK' 
            ? cert.book_title || tb('certificates.card.unknownBook')
            : `${tb('certificates.card.comprehensive')} (${cert.used_book_count || 0}${tb('certificates.card.books')})`
          }
        </h3>

        {/* Scores */}
        <div className="cert-scores">
          <div className="score-item level-score">
            <div className="score-icon" style={{ color: levelColor }}>L</div>
            <div className="score-content">
              <div className="score-label">{tb('certificates.card.level')}</div>
              <div className="score-value" style={{ color: levelColor }}>
                Level {cert.level}
              </div>
            </div>
          </div>

          <div className="score-item overall-score">
            <div className="score-icon">S</div>
            <div className="score-content">
              <div className="score-label">{tb('certificates.card.overallScore')}</div>
              <div className="score-value">{cert.overall_score}</div>
            </div>
          </div>

          <div className="score-item ap-score">
            <div className="score-icon">AP</div>
            <div className="score-content">
              <div className="score-label">AP</div>
              <div className="score-value" style={{ color: apGrade.color }}>
                {cert.absolute_percentile}
              </div>
            </div>
          </div>
        </div>

        {/* AP Grade Badge */}
        <div className="ap-grade-badge" style={{ background: `${apGrade.color}20`, color: apGrade.color, borderColor: apGrade.color }}>
          {apGrade.label}
        </div>

        {/* Footer */}
        <div className="cert-card-footer">
          <div className="cert-date">
            {new Date(cert.issued_at).toLocaleDateString('ko-KR')}
          </div>
          <div className="cert-status" style={{ color: cert.status === 'active' ? 'var(--duo-green)' : '#999' }}>
            {cert.status === 'active' ? 'Active' : 'Inactive'}
          </div>
        </div>
      </div>

      {/* Hover Effect Overlay */}
      <div className="cert-card-overlay">
        <div className="overlay-content">
          <span className="view-details-text">{tb('certificates.card.viewDetails')}</span>
          <span className="arrow-icon">></span>
        </div>
      </div>
    </div>
  );
};

export default CertificatesPage;

